module.exports = "/assets/3b57f1ae6a75630981862b683f6d7bfc.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/I2.png
// module id = 2584
// module chunks = 0